import { GalleryFieldInput } from '../../GalleryFieldInput'
import type { FieldInputProps } from '../types'

/**
 * EDIT-mode adapter dla FieldType=GALLERY. Wymagania jak FileInput plus value to
 * tablica fileId (Number).
 */
export function GalleryInput({ field, value, onChange, disabled, contractId }: FieldInputProps) {
  if (!contractId || !field.documentTypeId) {
    return <div className="text-xs text-rose-600 italic">Pole GALERIA wymaga podpiętego typu dokumentu i kontekstu umowy.</div>
  }
  const ids: number[] = Array.isArray(value)
    ? value.map(v => Number(v)).filter(n => !Number.isNaN(n))
    : []
  return (
    <GalleryFieldInput
      contractId={contractId}
      documentTypeId={field.documentTypeId}
      value={ids}
      onChange={(next) => onChange(next)}
      disabled={disabled}
    />
  )
}
